import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import {
  setAboutVisible,
  setCheckUpdateVisible,
  setDownloadPathVisible,
  setOperationMenuVisible,
  setPhoneVisible,
  setReleaseNotesVisible,
  setUserFeedbackVisible,
} from '../actions/layout';
import { deleteFeedbackHot, setFeedbackTab } from '../actions/userFeedback';
import { logging } from '../actions/log';
import { DEVELOPER_URL, USER_FEEDBACK_URL, APP_VERSION, APP_VERSION_D } from '../config';
import { cacheKeys } from '../constants/storageKeys';
import styles from './OperationMenu.module.less';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
// 独立包-检查更新版本信息
const selectNewVersionInfo = createSelector(
  state => state.layout,
  Layout => Layout.newVersionInfo,
);
const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);
const selectFeedbackHot = createSelector(
  state => state.userFeedback,
  userFeedback => userFeedback.feedbackHot,
);

export default memo(() => {
  const dispatch = useDispatch();
  const newVersionInfo = useSelector(selectNewVersionInfo);
  const logInfoData = useSelector(selectLogInfo);
  const [startInfo, setStartInfo] = useState({});
  const releaseNotesVersion = localStorage.getItem(cacheKeys.RELEASE_NOTES_VERSION);
  const userInfo = useSelector(selectUserInfo);
  const feedbackHot = useSelector(selectFeedbackHot);
  const [loginStatus, setLoginStatus] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const login_status = window.CallNativeMethod('get_login_status');
    if (!(login_status !== '1' || !userInfo.st)) {
      setLoginStatus(true);
    } else {
      setLoginStatus(false);
    }
  }, [userInfo]);
  /**
   * 初始化信息
   */
  useEffect(() => {
    // 获取startInfo
    const startInfoStr = localStorage.getItem(cacheKeys.START_INFO);
    const startInfos = JSON.parse(startInfoStr || '{}');
    setStartInfo(startInfos);
  }, [newVersionInfo]);

  const closeOtherDialog = useCallback(
    dialog => {
      dispatch(setOperationMenuVisible(false));
      dispatch(setDownloadPathVisible(dialog === 'Setting'));
      dispatch(setAboutVisible(dialog === 'About'));
      dispatch(setPhoneVisible(dialog === 'Phone'));
      dispatch(setCheckUpdateVisible(dialog === 'CheckUpdate'));
      dispatch(setReleaseNotesVisible(dialog === 'ReleaseNotes'));
      dispatch(setUserFeedbackVisible(dialog === 'userFeedback'));
    },
    [dispatch],
  );

  const handleSetting = useCallback(
    ev => {
      // 点击 下载管理 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Setting',
          label: '',
          param2: {
            source: 'HomePage',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      ev.stopPropagation();
      closeOtherDialog('Setting');
    },
    [dispatch, logInfoData],
  );

  const handleFeedback = ev => {
    // 点击 下载管理 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Feedback',
        label: '',
        param2: {
          source: 'HomePage',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    ev.stopPropagation();
    // 我要反馈的屏蔽
    closeOtherDialog('userFeedback');

    if (loginStatus && feedbackHot) {
      dispatch(deleteFeedbackHot());
      dispatch(setFeedbackTab('record'));
    }
    // window.open(USER_FEEDBACK_URL);
  };

  const handleAbout = useCallback(
    ev => {
      // 点击 关于 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'About',
          label: '',
          param2: {
            source: 'HomePage',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      ev.stopPropagation();
      closeOtherDialog('About');
    },
    [dispatch, logInfoData],
  );
  const handleCheckUpdate = useCallback(
    ev => {
      // 点击 check更新 打桩
      dispatch(
        logging({
          category: 'R',
          action: 'About_Update',
          label: '',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            mes: newVersionInfo && newVersionInfo.error && 'INDE_GET_LATEST_UPDATE failed',
            update: newVersionInfo && newVersionInfo.error ? 0 : 1,
            updateversion: newVersionInfo && newVersionInfo.versionName,
          },
        }),
      );
      ev.stopPropagation();
      closeOtherDialog('CheckUpdate');
    },
    [dispatch, logInfoData],
  );

  const handleDeveloper = useCallback(
    ev => {
      // 点击 商业合作 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'business',
          label: '',
          param2: {
            source: 'HomePage',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      ev.stopPropagation();
      closeOtherDialog('Trade');
      window.open(DEVELOPER_URL);
    },
    [dispatch, logInfoData],
  );

  // const handlePhone = useCallback(
  //   ev => {
  //     // 点击 关于 打桩
  //     dispatch(
  //       logging({
  //         category: 'C',
  //         action: 'Phone',
  //         label: '',
  //         param2: {
  //           source: 'HomePage',
  //           source_p: logInfoData.source_p,
  //           source_pp: logInfoData.source_pp,
  //         },
  //       }),
  //     );
  //     ev.stopPropagation();
  //     closeOtherDialog('Phone');
  //   },
  //   [dispatch, logInfoData],
  // );

  const handleReleaseNotes = useCallback(
    ev => {
      // 点击 关于 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'ReleaseNotes',
          label: '',
          param2: {
            source: 'HomePage',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      ev.stopPropagation();
      window.localStorage.setItem(
        cacheKeys.RELEASE_NOTES_VERSION,
        startInfo.isDStore ? APP_VERSION_D : APP_VERSION,
      );
      closeOtherDialog('ReleaseNotes');
    },
    [dispatch, logInfoData, startInfo],
  );

  return (
    <div className={styles.operation_menu}>
      <a className="line" onClick={handleSetting}>
        <i className="iconfont icon-toolbar_setting" />
        <span className="line-text">设置中心</span>
      </a>
      <a className="line" onClick={handleFeedback}>
        {loginStatus && feedbackHot && <div className={styles.hot} />}
        <i className="iconfont icon-toolbar_feedback" />
        <span className="line-text">我要反馈</span>
      </a>
      {startInfo && startInfo.isDStore && (
        <a className="line" onClick={handleCheckUpdate}>
          {newVersionInfo && newVersionInfo.versionName && <div className={styles.hot} />}
          <i className="iconfont icon-toolbar_update" />
          <span className="line-text">检查更新</span>
        </a>
      )}
      <a className="line" onClick={handleAbout}>
        <i className="iconfont icon-toolbar_about" />
        <span className="line-text">关于我们</span>
      </a>
      <a className="line" onClick={handleDeveloper}>
        <i className="iconfont icon-toolbar_trade" />
        <span className="line-text">商务合作</span>
      </a>
      <a className="line" onClick={handleReleaseNotes}>
        {releaseNotesVersion !== (startInfo.isDStore ? APP_VERSION_D : APP_VERSION) && (
          <div className={styles.hot} />
        )}
        <i className="iconfont icon-new_features" />
        <span className="line-text">新版特性</span>
      </a>
    </div>
  );
});
